<script setup>
</script>
<template>
  <div class="audit-evidence audit-evidence-cross-page h-100">
    <div class="row mb-1">
      <div class="col-md-6">
        <div class="cross-explainer py-3 px-2">
          <!-- Top row: Page A — check connector — Page B -->
          <div class="row align-items-center g-3 position-relative">
            <div class="col text-center">
              <div class="window-card mx-auto"></div>
              <div class="caption">This Page</div>
            </div>

            <div class="col-2 d-flex align-items-center justify-content-center position-relative">
              <div class="bridge w-100 position-relative">
                <div class="h-line"></div>
                <div class="center-check bg-white rounded-circle">
                  <i class="bi bi-check2 text-success"></i>
                </div>
              </div>
            </div>

            <div class="col text-center">
              <div class="window-card mx-auto"></div>
              <div class="caption">Page B</div>
            </div>
          </div>

          <div class="row align-items-start g-3 justify-content-center">

            <div class="col-4 text-center position-relative" style="margin-left:-10px">
              <!-- small vertical connector up to the center check -->
              <div class="v-line mx-auto"></div>
              <div class="window-card mx-auto mt-1">
                 <div class="window-card mx-auto mt-1" style="top:-10px;left:6px;z-index:10"></div>
              </div>

              <div class="caption text-nowrap">+10 Pages</div>
            </div>


          </div>
        </div>
      </div>
      <div class="col col-6">
                      <div class="fw-semibold mb-1">Cross-referencing 12 pages.</div>
              <div class="text-muted small">Verify that your page content is consistent between all your different pages.</div>
        <div class="mt-3">
          <router-link :to="{'name': 'crossReferenceIssues'}" class="btn btn-alt-info btn-sm">View Full Report</router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
.cross-explainer {
  background: #f7f9fb; /* soft light like the mock */
  border-radius: 8px;
}

.window-card {
  width: 56px;
  height: 36px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 6px;
  background: #fff;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.06);
  position: relative;
}

.window-card::before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  height: 8px;
  background: #eef2f7;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}

.window-card::after {
  content: "";
  position: absolute;
  left: 10px;
  right: 10px;
  top: 16px;
  height: 3px;
  background: #e6eef8;
  box-shadow: 0 8px 0 #e6eef8;
}

.caption {
  color: #838383;
  font-size: 11px;
  margin-top: 1px;
}

.bridge .h-line {
  position: absolute;
  top: 50%;
  left: -10px;
  right: -10px;
  height: 2px;
  background: #9ad3b0; /* soft green */
  transform: translateY(-50%);
}

.bridge .center-check {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 24px;
  height: 24px;
  border: 2px solid #9ad3b0;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: translate(-50%, -50%);
}

.bridge .center-check i {
  font-size: 16px;
}

.v-line {
  position: absolute;
  width: 2px;
  left: 36px;
  top: -16px;
  height: 6px;
  background: #9ad3b0;
}

.checks li {
  line-height: 1.6;
}

</style>